<template>
  <div :class="getScreen ? 'm-page-wrapper ' : 'd-page-wrapper'">
    <a-card class="m-wrong m-height-full m-display-flex flex-column">
      <m-anim
        :options="noConnection"
        class="anim"
        :height="getScreen ? 200 : 500"
        :width="getScreen ? 200 : 500"
      ></m-anim>
      <h1 class="margin-remove">Error Connection!</h1>
      <h3 class="margin-bottom">Please contact your administrator</h3>

      <a-button type="primary" @click="backtopandapa" block>Back To Pandapakita</a-button>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import noCon from "@/assets/anim/noInternetConnection.json";
export default {
  name: "E404",
  components: { "m-anim": lottie },
  data() {
    return {
      noConnection: { animationData: noCon, loop: true }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen"])
  },
  methods: {
    backtopandapa() {
      window.location = process.env.VUE_APP_PANDAPAKITA;
    }
  }
};
</script>

<style>
</style>